// src/services/inventoryCategoryService.js
import { authenticatedFetch, handleApiError } from './api';

const API_URL = '/inventory-categories';

const getAllCategories = () => {
  return authenticatedFetch(API_URL).catch(handleApiError);
};

const createCategory = (categoryData) => {
  return authenticatedFetch(API_URL, {
    method: 'POST',
    body: JSON.stringify(categoryData),
  }).catch(handleApiError);
};

const updateCategory = (id, categoryData) => {
  return authenticatedFetch(`${API_URL}/${id}`, {
    method: 'PUT',
    body: JSON.stringify(categoryData),
  }).catch(handleApiError);
};

const deleteCategory = (id) => {
  return authenticatedFetch(`${API_URL}/${id}`, {
    method: 'DELETE',
  }).catch(handleApiError);
};

const inventoryCategoryService = {
  getAllCategories,
  createCategory,
  updateCategory,
  deleteCategory,
};

export default inventoryCategoryService;
